<template>
  <div id="root">
    <div style="outline:none" tabindex="-1" role="group">
      <div class="main-container">
        <div class="app-container">
          <div class="main-page-container">
            <div style="outline:none" tabindex="-1" role="group">
              <div class="page-container article-type">
                <Header />
                <div class="page-wrapper bg-layer">
                  <div
                    class="sections-wrapper default-wrapper"
                    style="visibility: inherit; opacity: 1;"
                  >
                    <section
                      style="z-index:6"
                      class="main-cover-component bg-layer introduction-layout cover-video-dsk cover-video-mb"
                    >
                      <div class="cover-container">
                        <div class="player-container">
                          <video
                            id="myVideo"
                            src="../assets/video/home.mp4"
                            poster="../assets/video/home.mp4"
                            preload="no"
                            autoplay="autoplay"
                            loop="loop"
                            webkit-playsinline=""
                            playsinline=""
                            x5-video-player-type="h5"
                            x5-video-player-fullscreen="true"
                            x5-video-orientation="portraint"
                            x-webkit-airplay="true"
                          >
                            <source
                              data-v-3f2db69e=""
                              src="../assets/video/home.mp4"
                              type="video/mp4"
                            />
                          </video>
                        </div>
                      </div>
                    </section>
                    <section
                      style="z-index:5"
                      class="introduction-component bg-layer content_block-layout"
                      ref="top01"
                    >
                      <div class="grid-wrapper">
                        <div class="grid-12 pad-mb sm-grid-10 container">
                          <div class="content-wrapper">
                            <div
                              class="content-component wysiwyg-layout introduction uppercase top"
                              :class="{ active: top01 }"
                            >
                              <p>从千姿斑斓的大自然里寻找灵感。</p>
                              <p>
                                一片绿叶的启迪，一缕清风、
                              </p>
                              <p>
                                一道虹彩、一脉温泉的心有灵犀，
                              </p>
                              <p>
                                孕育了无数颠倒众生的衣饰传奇。
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                    <section
                      style="z-index:4"
                      class="content-block-component bg-layer  styles_push-layout"
                      ref="about"
                    >
                      <div class="content-block-wrapper ">
                        <div class="content-block-container grid-wrapper">
                          <div class="content-block-subcontainer grid-12">
                            <ul class="items-container grid-12">
                              <li class="content-item-component">
                                <div class="content-item-container grid-12">
                                  <div
                                    class="grid-12 sm-grid-5 img-container sm-pad-1-right md-pad-2-right left-img"
                                    :class="{ active: aboutShow }"
                                  >
                                    <div class="img-wrapper">
                                      <div
                                        class="cover-img-component img-loaded"
                                      >
                                        <div class="img-wrapper grid-12">
                                          <img
                                            alt="Campaign Ss21 1800x2700"
                                            src="../assets/img/icb-peding-01.png"
                                            v-prlx
                                            style="transform: matrix(1, 0, 0, 1, 0, 0); height: 685px; width: 560px; top: -40px; left: 0px;"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="content-container grid-12 pad-mb sm-grid-7 centered"
                                  >
                                    <div
                                      class="content-wrapper sm-pad-4-sides s-layout"
                                      style="transform: matrix(1, 0, 0, 1, 0, 0);"
                                    >
                                      <h3
                                        class="subtitle-component bigger uppercase"
                                      >
                                        公司介绍
                                      </h3>
                                      <div class="button-component">
                                        <p class="text">
                                          上海赢裳恩服饰有限公司于2019年03月25日成立。公司经营范围包括：销售：服装服饰及辅料、日用百货、针纺织品、家用电器、工艺品，品牌策划，品牌管理，市场营销策划等。
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </section>
                    <section
                      style="z-index:4;padding-top:0"
                      class="content-block-component bg-layer  styles_push-layout"
                      ref="pinpai"
                    >
                      <div class="content-block-wrapper ">
                        <div class="content-block-container grid-wrapper">
                          <div class="content-block-subcontainer grid-12">
                            <ul class="items-container grid-12">
                              <li class="content-item-component reverse-item">
                                <div class="content-item-container grid-12">
                                  <div
                                    class="grid-12 sm-grid-5 img-container sm-pad-1-left md-pad-2-left right-img"
                                    :class="{ active: pinpaiShow }"
                                  >
                                    <div class="img-wrapper">
                                      <div
                                        class="cover-img-component img-loaded"
                                      >
                                        <div class="img-wrapper grid-12">
                                          <img
                                            alt="0515 Icicle5696"
                                            src="../assets/img/icb-opening-02.png"
                                            v-prlx
                                            style="transform: matrix(1, 0, 0, 1, 0, 0); height: 685px; width: 560px;  top: 0px; left: -36px;"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="content-container grid-12 pad-mb sm-grid-7 centered"
                                  >
                                    <div
                                      class="content-wrapper sm-pad-4-sides s-layout"
                                      style="transform: matrix(1, 0, 0, 1, 0, 0);"
                                    >
                                      <h3
                                        class="subtitle-component bigger uppercase"
                                      >
                                        品牌故事
                                      </h3>
                                      <div class="button-component">
                                        <div class="link-container">
                                          <p class="text">
                                            以成熟女性为主顾的23区女装，款式设计上极富"女人味"，特别注重女性对美的追求。无数的奇思妙想被设计师转化为实实在在的设计，在充满了想象的款式中每一件每一款都犹如"众星捧月"般唯美。<br />
                                            ICB是从世界的视角出发，为女性彰显自我及社会价值的品牌。多样中显露清新，
                                            传统中不乏新颖。更重要的是随时呈现出个性。
                                            召唤当代女性内在信心的ICB，
                                            在基础风格中用时尚洗炼优雅的风格。
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </section>
                    <section
                      style="z-index:4;padding-top:0"
                      class="content-block-component bg-layer  styles_push-layout"
                      ref="chanp"
                    >
                      <div class="content-block-wrapper ">
                        <div class="content-block-container grid-wrapper">
                          <div class="content-block-subcontainer grid-12">
                            <ul class="items-container grid-12">
                              <li class="content-item-component">
                                <div class="content-item-container grid-12">
                                  <div
                                    class="grid-12 sm-grid-5 img-container sm-pad-1-right md-pad-2-right left-img"
                                    :class="{ active: chanpShow }"
                                  >
                                    <div class="img-wrapper">
                                      <div
                                        class="cover-img-component img-loaded"
                                      >
                                        <div class="img-wrapper grid-12">
                                          <img
                                            alt="0514 Icicle2133"
                                            src="../assets/img/icb-opening-03.png"
                                            v-prlx
                                            style="transform: matrix(1, 0, 0, 1, 0, 0); height: 685px; width: 560px; top: 0px; left: -36px;"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="content-container grid-12 pad-mb sm-grid-7 centered"
                                  >
                                    <div
                                      class="content-wrapper sm-pad-4-sides s-layout"
                                      style="transform: matrix(1, 0, 0, 1, 0, 0);"
                                    >
                                      <h3
                                        class="subtitle-component bigger uppercase"
                                      >
                                        产品设计
                                      </h3>
                                      <div class="button-component">
                                        <div class="link-container">
                                          <p class="text">
                                            寻找女性与世界之间，最完美的平衡点。去繁化简，展现对生活最本真的表达。这就是我们的时尚态度：温润
                                            - 从容 - 纯粹。<br />
                                            关注天然的高贵美感，可持续的环保材质和经久的品质。设计的每个环节都心存敬意，以真挚的匠人情怀和娴熟技艺，打造富有简约美学的永续时装。
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </section>
                    <section
                      class="iconic-products-push-component bg-layer store_block-layout"
                      style="z-index: 3;"
                      ref="big"
                    >
                      <div class="grid-wrapper pc">
                        <!-- <div class="titles-container grid-12 pad-mb sm-grid-6">
                          <h2
                            class="title-component default default centered uppercase"
                            style="opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);"
                          >
                            之禾经典
                          </h2>
                          <div
                            class="content-component wysiwyg-layout default centered"
                            style="opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);"
                          >
                            ICICLE之禾使用天然原料制作舒适的高品质服饰，满足不同场合的着装需求，展示天然之美。
                          </div>
                        </div> -->
                        <div class="products-wrapper">
                          <ul
                            class="products-layout specify-mb grid-12 products-grid-6"
                            style="display: flex;"
                          >
                            <li
                              class="product-container grid-12 sm-grid-4 big"
                              :class="{ active: bigFlag }"
                            >
                              <div class="iconic-img-component bigger">
                                <div class="iconic-container">
                                  <div class="cover-img-component img-loaded">
                                    <div class="img-wrapper grid-12">
                                      <img
                                        src="../assets/img/icb-opening-04.png"
                                        v-prlx
                                        style="opacity: 1; transform: translate3d(0px, 10.26px, 0px); width:390px; height: 460px"
                                      />
                                    </div>
                                  </div>
                                  <div class="content-wrapper md-grid-10">
                                    <div class="content-container">
                                      <h3
                                        class="subtitle-component bigger white centered uppercase"
                                      >
                                        23区
                                      </h3>
                                      <div
                                        class="button-component white no-padding underline"
                                      >
                                        <div class="link-container">
                                          <router-link
                                            :to="{
                                              name: 'pro',
                                              query: { id: 90, type: '23区' }
                                            }"
                                            >了解更多</router-link
                                          ><span class="line-decorator"></span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </li>
                            <li
                              class="product-container grid-12 sm-grid-4 big"
                              :class="{ active: bigFlag }"
                            >
                              <div class="iconic-img-component bigger">
                                <div class="iconic-container">
                                  <div
                                    class="cover-img-component img-loaded"
                                    style="opacity: 1;"
                                  >
                                    <div class="img-wrapper grid-12">
                                      <img
                                        src="../assets/img/icb-opening-06.png"
                                        v-prlx
                                        style="opacity: 1; transform: translate3d(0px, 10.26px, 0px);width:390px; height: 460px"
                                      />
                                    </div>
                                  </div>
                                  <div class="content-wrapper md-grid-10">
                                    <div class="content-container">
                                      <h3
                                        class="subtitle-component bigger white centered uppercase"
                                      >
                                        ICB
                                      </h3>
                                      <div
                                        class="button-component white no-padding underline"
                                      >
                                        <div class="link-container">
                                          <router-link
                                            :to="{
                                              name: 'pro',
                                              query: { id: 91, type: 'icb' }
                                            }"
                                            >了解更多</router-link
                                          ><span class="line-decorator"></span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </li>
                            <li
                              class="product-container grid-12 sm-grid-4 big"
                              :class="{ active: bigFlag }"
                            >
                              <div class="iconic-img-component bigger">
                                <div class="iconic-container">
                                  <div
                                    class="cover-img-component img-loaded"
                                    style="opacity: 1;"
                                  >
                                    <div class="img-wrapper grid-12">
                                      <img
                                        src="../assets/img/icb-opening-05.png"
                                        v-prlx
                                        style="opacity: 1; transform: translate3d(0px, 10.26px, 0px);width:390px; height: 460px"
                                      />
                                    </div>
                                  </div>
                                  <div class="content-wrapper md-grid-10">
                                    <div class="content-container">
                                      <h3
                                        class="subtitle-component bigger white centered uppercase"
                                      >
                                        店铺
                                      </h3>
                                      <div
                                        class="button-component white no-padding underline"
                                      >
                                        <div class="link-container">
                                          <router-link to="/locator"
                                            >了解更多</router-link
                                          ><span class="line-decorator"></span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                        <div class="btn-container pc">
                          <div
                            class="button-component cta-underline grey underline"
                          >
                            <div class="link-container">
                              <p>
                                查看全部
                              </p>
                              <span class="line-decorator"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <swiper
                        :options="swiperOption1"
                        ref="swiperThumbs"
                        class="pro-bottom m big"
                        :class="{ active: bigFlag }"
                      >
                        <!-- slides -->
                        <swiper-slide>
                          <div class="iconic-img-component bigger">
                            <div class="iconic-container">
                              <div class="cover-img-component img-loaded">
                                <div class="img-wrapper grid-12">
                                  <img
                                    src="../assets/img/icb-opening-04.png"
                                    v-prlx
                                    style="opacity: 1; transform: translate3d(0px, 10.26px, 0px); width:390px; height: 460px"
                                  />
                                </div>
                              </div>
                              <div class="content-wrapper md-grid-10">
                                <div class="content-container">
                                  <h3
                                    class="subtitle-component bigger white centered uppercase"
                                  >
                                    23区
                                  </h3>
                                  <div
                                    class="button-component white no-padding underline"
                                  >
                                    <div class="link-container">
                                      <router-link
                                        :to="{
                                          name: 'pro',
                                          query: { id: 90, type: '23区' }
                                        }"
                                        >了解更多</router-link
                                      ><span class="line-decorator"></span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </swiper-slide>
                        <swiper-slide>
                          <div class="iconic-img-component bigger">
                            <div class="iconic-container">
                              <div
                                class="cover-img-component img-loaded"
                                style="opacity: 1;"
                              >
                                <div class="img-wrapper grid-12">
                                  <img
                                    src="../assets/img/icb-opening-06.png"
                                    v-prlx
                                    style="opacity: 1; transform: translate3d(0px, 10.26px, 0px);width:390px; height: 460px"
                                  />
                                </div>
                              </div>
                              <div class="content-wrapper md-grid-10">
                                <div class="content-container">
                                  <h3
                                    class="subtitle-component bigger white centered uppercase"
                                  >
                                    ICB
                                  </h3>
                                  <div
                                    class="button-component white no-padding underline"
                                  >
                                    <div class="link-container">
                                      <router-link
                                        :to="{
                                          name: 'pro',
                                          query: { id: 91, type: 'icb' }
                                        }"
                                        >了解更多</router-link
                                      ><span class="line-decorator"></span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </swiper-slide>
                        <swiper-slide>
                          <div class="iconic-img-component bigger">
                            <div class="iconic-container">
                              <div
                                class="cover-img-component img-loaded"
                                style="opacity: 1;"
                              >
                                <div class="img-wrapper grid-12">
                                  <img
                                    src="../assets/img/icb-opening-05.png"
                                    v-prlx
                                    style="opacity: 1; transform: translate3d(0px, 10.26px, 0px);width:390px; height: 460px"
                                  />
                                </div>
                              </div>
                              <div class="content-wrapper md-grid-10">
                                <div class="content-container">
                                  <h3
                                    class="subtitle-component bigger white centered uppercase"
                                  >
                                    店铺
                                  </h3>
                                  <div
                                    class="button-component white no-padding underline"
                                  >
                                    <div class="link-container">
                                      <router-link to="/locator"
                                        >了解更多</router-link
                                      ><span class="line-decorator"></span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </swiper-slide>
                        <!-- Optional controls -->

                        <!-- 如果需要导航条-->
                      </swiper>
                    </section>

                    <section
                      style="z-index:2"
                      class="store-component"
                      ref="bottom"
                    >
                      <div
                        class="grid-12 bg-layer centered show"
                        :class="{ active: show }"
                      >
                        <div class="cover-img-container">
                          <div class="cover-img-component img-loaded">
                            <div class="img-wrapper grid-12">
                              <img
                                alt="Icicle George V Store Opening 08"
                                src="../assets/img/icicle-george-v-store-opening-08.jpg"
                                v-prlx
                                style="opacity: 1; transform: translate3d(0px, -19.8px, 0px); height: 1145px; width: 1920px; top: -117px; left: 0px;"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="grid-wrapper">
                          <div
                            class="store-container grid-12 sm-grid-8 md-grid-7 centered"
                          >
                            <div class="grid-12 pad-mb">
                              <h3
                                class="subtitle-component super-small uppercase"
                                style="opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);"
                              >
                                <img src="../assets/img/logo.png" width="150" />
                              </h3>
                              <h2
                                class="title-component default uppercase"
                                style="opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);"
                              >
                                微信公众号
                              </h2>
                              <div
                                class="address-container"
                                style="opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);"
                              >
                                <!-- <p>上海市南京路**号</p>
                                <p>+86 88888888</p> -->
                              </div>
                              <div>
                                <img
                                  src="../assets/img/wm001.png"
                                  width="150"
                                />
                              </div>
                              <div
                                class="open-container"
                                style="opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);"
                              >
                                <p class="content-component default malta">
                                  地址：上海市闵行区莲花路1308号A座301-302
                                </p>
                              </div>
                            </div>
                            <div class="cta-container">
                              <div
                                class="button-component grey"
                                style="opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);"
                              >
                                <div class="link-container">
                                  <router-link to="/contact"
                                    >立即体验</router-link
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                  <Footer />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
window.onerror = function() {
  return true;
};
import Header from "../components/header.vue";
import Footer from "../components/footer.vue";
export default {
  name: "locator",
  components: {
    Header,
    Footer
  },
  data() {
    return {
      aboutShow: false,
      pinpaiShow: false,
      chanpShow: false,
      top01: false,
      bigFlag: false,
      show: false,
      swiperOption1: {
        // 参数选项,显示小点
        pagination: ".swiper-pagination",
        slidesPerView: 1,
        spaceBetween: 10
      }
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    //在组件生命周期结束的时候销毁。
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      let b =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (b > this.$refs.top01.offsetTop - 300) {
        this.top01 = true;
      }
      if (b > this.$refs.about.offsetTop - 300) {
        this.aboutShow = true;
      }
      if (b > this.$refs.pinpai.offsetTop - 300) {
        this.pinpaiShow = true;
      }
      if (b > this.$refs.chanp.offsetTop - 300) {
        this.chanpShow = true;
      }
      if (b > this.$refs.big.offsetTop - 300) {
        this.bigFlag = true;
      }
      if (b > this.$refs.bottom.offsetTop - 300) {
        this.show = true;
      }
    }
  }
};
</script>

<style scoped>
.left-img {
  transform: matrix(1, 0, 0, 1, 20, 30);
  transition: all 1s;
}
.right-img {
  transform: matrix(1, 0, 0, 1, -20, 30);
  transition: all 1s;
}
.left-img.active,
.right-img.active {
  transform: matrix(1, 0, 0, 1, 0, 0);
}
.left-img .img-loaded,
.right-img .img-loaded {
  opacity: 0;
  transition: all 1s;
}
.left-img.active .img-loaded,
.right-img.active .img-loaded {
  opacity: 1;
}
.left-img + div .subtitle-component,
.left-img + div .button-component {
  transform: matrix(1, 0, 0, 1, 0, 30);
  opacity: 0;
  transition: all 1s;
}
.right-img + div .subtitle-component,
.right-img + div .button-component {
  transform: matrix(1, 0, 0, 1, 0, 30);
  opacity: 0;
  transition: all 1s;
}
.left-img + div .content-wrapper {
  transform: matrix(1, 0, 0, 1, 20, 30);
  transition: all 1s;
}
.right-img + div .content-wrapper {
  transform: matrix(1, 0, 0, 1, -20, 30);
  transition: all 1s;
}
.right-img.active + div .content-wrapper,
.left-img.active + div .content-wrapper {
  transform: matrix(1, 0, 0, 1, 0, 0);
}
.left-img.active + div .subtitle-component,
.left-img.active + div .button-component,
.right-img.active + div .subtitle-component,
.right-img.active + div .button-component {
  transform: matrix(1, 0, 0, 1, 0, 0);
  opacity: 1;
}
.top {
  transform: matrix(1, 0, 0, 1, 0, 30);
  transition: all 1s;
  opacity: 0;
}
.top.active {
  transform: matrix(1, 0, 0, 1, 0, 0);
  opacity: 1;
}
.big {
  visibility: hidden;
  opacity: 0;
  transform: matrix(1, 0, 0, 1, 50, 50);
  transition: all 1s;
}
.big .img-loaded {
  opacity: 0;
}
.big.active .img-loaded {
  opacity: 1;
}
.big.active {
  transform: matrix(1, 0, 0, 1, 0, 0);
  opacity: 1;
  visibility: inherit;
}
.show {
  visibility: hidden;
  opacity: 0;
  transition: all 1s;
}
.show.active {
  visibility: inherit;
  opacity: 1;
}
</style>